/** InsCoder 2026-09-17 B + HP 26 logo card carousel: swiper + autoplay, no nav buttons **/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-hp26-lcc]';
  var SLIDER_SELECTOR = '[data-hp26-swiper]';
  var AUTOPLAY_DELAY = 3000;

  function initSection(root) {
    if (!root || root.dataset.hp26LccReady === 'true') return;

    var sliderEl = root.querySelector(SLIDER_SELECTOR);
    if (!sliderEl) return;
    root.dataset.hp26LccReady = 'true';

    if (!window.Swiper || !sliderEl.querySelector('.swiper-slide')) return;

    new window.Swiper(sliderEl, {
      slidesPerView: 'auto',
      loop: true,
      /** InsCoder 2026-09-17 B + 3s autoplay loop, keeps running after a manual swipe **/
      autoplay: {
        delay: AUTOPLAY_DELAY,
        disableOnInteraction: false
      },
      /** InsCoder 2026-09-17 E + 3s autoplay loop, keeps running after a manual swipe **/
      /** InsCoder 2026-09-17 B + Mobile: 8px gutter, left aligned. Desktop: 12px gutter, centred **/
      breakpoints: {
        0: {
          spaceBetween: 8,
          centeredSlides: false
        },
        990: {
          spaceBetween: 12,
          centeredSlides: true
        }
      }
      /** InsCoder 2026-09-17 E + Mobile: 8px gutter, left aligned. Desktop: 12px gutter, centred **/
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;

    var root = target.dataset && target.dataset.hp26Lcc !== undefined
      ? target
      : target.querySelector(ROOT_SELECTOR);

    if (root) initSection(root);
    else initAll();
  });
})();
/** InsCoder 2026-09-17 E + HP 26 logo card carousel: swiper + autoplay, no nav buttons **/
